import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LorenNumberPipe } from './pipes/loren-number.pipe';



@NgModule({
	declarations: [
		LorenNumberPipe
	],
	exports: [
		LorenNumberPipe
	],
	imports: [
		CommonModule
	]
})
export class LorenNumberModule { }
